export default __webpack_public_path__ + "static/media/no-message.8256c7ae.png";